import { render, staticRenderFns } from "./WorksList.vue?vue&type=template&id=4b75a7ee&scoped=true&"
import script from "./WorksList.vue?vue&type=script&lang=js&"
export * from "./WorksList.vue?vue&type=script&lang=js&"
import style0 from "./WorksList.vue?vue&type=style&index=0&id=4b75a7ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b75a7ee",
  null
  
)

export default component.exports